module.exports = "https://cdn.hellotech.com/client-assets/surface_drywall_e7191d306a3800b5dafa1dece24e94e8.png";